var map = {
	"./BG1.jpg": "2b0c",
	"./Header1.jpg": "8f09",
	"./Header2.jpg": "a10f",
	"./Header3.jpg": "ed66",
	"./Header4.jpg": "fa98",
	"./cerf1.jpg": "ede9",
	"./cerf10.jpg": "7f38",
	"./cerf11.jpg": "85af",
	"./cerf12.jpg": "8dea",
	"./cerf13.jpg": "7e07",
	"./cerf2.jpg": "bb6f",
	"./cerf3.jpg": "714f",
	"./cerf4.jpg": "ee03",
	"./cerf5.jpg": "e3a3",
	"./cerf6.jpg": "9891",
	"./cerf7.jpg": "5d15",
	"./cerf8.jpg": "c578",
	"./cerf9.jpg": "1e7e",
	"./cert14.jpg": "59f6",
	"./cert15.jpg": "a804",
	"./copieren.jpg": "0568",
	"./ecommerce.jpg": "8f92",
	"./financial.jpg": "b049",
	"./leer.jpg": "f457",
	"./main2.jpg": "4e18",
	"./man.jpg": "4d69",
	"./monitor.jpg": "73e9",
	"./network.jpg": "d53e",
	"./pc-1595125_1920.jpg": "0d91",
	"./question.jpg": "fabc",
	"./startup.jpg": "ec01",
	"./technology.jpg": "1771"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";